import { invert } from 'lodash';

// TODO Would be nice to make the meal types consistent

// Used in POS and meal summary
export const MealTypesEnum = {
  Breakfast: 'B',
  Lunch: 'L',
  Other: 'O',
  Supper: 'S',
};

export const MealTypeKeysEnum = invert(MealTypesEnum);

// Used for menus
export const MenuMealTypesEnum = {
  ALL: -1,
  Breakfast: 0,
  Lunch: 1,
  'After-school Snack': 2,
  Supper: 3,
};

export const MenuMealTypeKeysEnum = invert(MenuMealTypesEnum);

// Used in Provision 2
export const MealTypeEnum = {
  Breakfast: 0,
  Lunch: 1,
  BreakfastLunchSupper: 2,
  Other: 3,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/MealTypesEnum.js